import {
  deleteDoc,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
  collection,
  addDoc,
} from "firebase/firestore";
import {
  AlbumsLikesRef,
  AlbumsRef,
  ContributorsInvitesRef,
  ContributorsRef,
  GroupRef,
  QTLikesRef,
  QuickTalesRef,
  db,
  storage,
} from "../../../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

export const getAllUsers = async () => {
  try {
    const response = await getDocs(ContributorsRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getUserGroups = async (userId) => {
  try {
    // Prepare the queries for parallel execution
    const queries = [
      query(GroupRef, where("createdBy", "==", userId)),
      query(GroupRef, where("members", "array-contains", userId)),
    ];

    // Execute queries in parallel
    const [createdResponse, memberResponse] = await Promise.all(
      queries.map((q) => getDocs(q))
    );

    // Combine and deduplicate documents based on their IDs (if necessary)
    const combinedDocs = [...createdResponse.docs, ...memberResponse.docs];
    const uniqueDocs = combinedDocs.reduce((acc, doc) => {
      acc[doc.id] = doc;
      return acc;
    }, {});

    return Object.values(uniqueDocs);
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getUserLikes = async (userId) => {
  try {
    // Define queries for QuickTales and Albums created by the user
    const QTQueryRef = query(QuickTalesRef, where("createdBy", "==", userId));
    const AlbumsQueryRef = query(AlbumsRef, where("user", "==", userId));

    // Fetch documents from Firestore
    const QTResponse = await getDocs(QTQueryRef);
    const AlbumsResponse = await getDocs(AlbumsQueryRef);

    // Initiate like queries in parallel for each QuickTale and Album
    const QTLikesPromises = QTResponse.docs.map(async (item) => {
      const queryRef = query(QTLikesRef, where("quicktale", "==", item.id));
      const response = await getDocs(queryRef);
      return response.docs.length; // Return the count of likes for each QuickTale
    });
    const AlbumsLikesPromises = AlbumsResponse.docs.map(async (item) => {
      const queryRef = query(AlbumsLikesRef, where("album", "==", item.id));
      const response = await getDocs(queryRef);
      return response.docs.length; // Return the count of likes for each Album
    });

    // Wait for all like queries to complete and sum the results
    const QTlikesResults = await Promise.all(QTLikesPromises);
    const AlbumslikesResults = await Promise.all(AlbumsLikesPromises);

    // Sum the total likes from both sources
    const totalLikes =
      QTlikesResults.reduce((sum, current) => sum + current, 0) +
      AlbumslikesResults.reduce((sum, current) => sum + current, 0);

    console.log("counts::", totalLikes);

    return totalLikes;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    return 0; // Return 0 likes in case of error
  }
};

// export const getUserLikes = async (userId) => {
//   try {
//     const QTQueryRef = query(QuickTalesRef, where("createdBy", "==", userId));
//     const AlbumsQueryRef = query(AlbumsRef, where("user", "==", userId));
//     const QTResponse = await getDocs(QTQueryRef);
//     const AlbumsResponse = await getDocs(AlbumsQueryRef);

//     // Use map to initiate all like queries in parallel
//     const QTLikesPromises = QTResponse.docs.map(async (item) => {
//       const queryRef = query(QTLikesRef, where("quicktale", "==", item.id));
//       const response = await getDocs(queryRef);
//       return response.docs; // Return the docs for each like query
//     });
//     // Use map to initiate all like queries in parallel
//     const AlbumsLikesPromises = AlbumsResponse.docs.map(async (item) => {
//       const queryRef = query(AlbumsLikesRef, where("album", "==", item.id));
//       const response = await getDocs(queryRef);
//       return response.docs; // Return the docs for each like query
//     });

//     // Wait for all like queries to complete
//     const QTlikesResults = await Promise.all(QTLikesPromises);
//     const AlbumslikesResults = await Promise.all(AlbumsLikesPromises);

//     // Flatten the array of arrays into a single array of docs
//     // const temp = [...QTlikesResults.flat(), AlbumslikesResults.flat()];
//     // return temp;

//     // Sum the total likes from both sources
//     const totalLikes =
//       QTlikesResults.reduce((sum, current) => sum + current, 0) +
//       AlbumslikesResults.reduce((sum, current) => sum + current, 0);

//     return totalLikes;

//   } catch (error) {
//     console.log("Error fetching data from Firestore:", error.message);
//     return [];
//   }
// };

export const deleteUser = async (id) => {
  const usersRef = doc(db, "users", id);
  return await deleteDoc(usersRef);
};
export const addUser = async (data) => {
  const usersRef = collection(db, "users");
  return await addDoc(usersRef, data);
};
export const updateUser = async (id, userDoc) => {
  const usersRef = doc(db, "users", id);
  return await updateDoc(usersRef, userDoc);
};

export const getFilterGAUsers = async (
  showAnonymousUsers,
  accountStatusFilterOptions,
  reportedStatusFilterOptions,
  dateSignupRange,
  setLoading,
  handleFilterModalClose
) => {
  // console.log("dates::", dateSignupRange);
  setLoading(true);

  // const deduplicate = (arr) => {
  //   const uniqueIds = new Set();
  //   const uniqueDocs = [];
  //   arr.forEach((doc) => {
  //     if (!uniqueIds.has(doc.id)) {
  //       uniqueIds.add(doc.id);
  //       uniqueDocs.push(doc);
  //     }
  //   });
  //   console.log("results:", uniqueDocs);
  //   handleFilterModalClose();
  //   return uniqueDocs;
  // };

  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = arr.filter((doc) => doc !== null).reduce((acc, doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        acc.push(doc);
      }
      return acc;
    }, []);
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };
  

  try {
    let results = [];

    const accountStatusOptions =
      accountStatusFilterOptions.length > 0
        ? accountStatusFilterOptions
        : [null];
    const reportedStatusOptions =
      reportedStatusFilterOptions.length > 0
        ? reportedStatusFilterOptions
        : [null];

    for (const accountStatus of accountStatusOptions) {
      for (const reportedStatus of reportedStatusOptions) {
        let queries = [];

        if (accountStatus !== null) {
          queries.push(
            where(
              "isActive",
              "==",
              accountStatus === "active"
                ? true
                : accountStatus === "inactive"
                ? false
                : undefined
            )
          );
        }

        if (reportedStatus !== null) {
          queries.push(where("reportedStatus", "==", reportedStatus));
        }

        if (
          dateSignupRange &&
          dateSignupRange.startDate &&
          dateSignupRange.endDate
        ) {
          queries.push(where("createdAt", ">=", dateSignupRange.startDate));
          queries.push(where("createdAt", "<=", dateSignupRange.endDate));
        }

        if (queries.length > 0) {
          const q = query(ContributorsRef, ...queries);
          const querySnapshot = await getDocs(q);

          // const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
          //   if (showAnonymousUsers[0] === "Anonymous Disabled") {
          //     if (doc.data().firstName == "Anonymous") {
          //       return;
          //     } else
          //       return {
          //         id: doc.id,
          //         ...doc.data(),
          //       };
          //     // return null;
          //   } else
          //     return {
          //       id: doc.id,
          //       ...doc.data(),
          //     };

          //   // if (showAnonymousUsers?.length > 0) {
          //   //   if (doc.data().firstName === "Anonymous") {
          //   //     return null;
          //   //   } else
          //   //     return {
          //   //       id: doc.id,
          //   //       ...doc.data(),
          //   //     };
          //   // }
          // });

          const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
            if (showAnonymousUsers[0] === "Anonymous Disabled") {
              if (
                doc.data().firstName === "Anonymous" ||
                doc.data().firstName === "Guest"
              ) {
                // Return null for anonymous or guest users when disabled
                return null;
              }
            }
            // Return non-anonymous/guest users or all users when allowed
            return {
              id: doc.id,
              ...doc.data(),
            };
          });

          const accountStatusResults = await Promise.all(fetchDetailsPromises);
          results = results.concat(accountStatusResults);
        }
      }
    }

    const uniqueResults = deduplicate(results ?? []);
    setLoading(false);
    return uniqueResults;
  } catch (error) {
    console.error("Error filtering users:", error);
    setLoading(false);
    return [];
  }
};

// export const getFilterGAUsers = async (
//   accountStatusFilterOptions,
//   reportedStatusFilterOptions,
//   // dateSignupFilterOptions,
//   dateSignupRange,
//   setLoading,
//   handleFilterModalClose
// ) => {
//   console.log("dates::", dateSignupRange);
//   setLoading(true);

//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     console.log("results:", uniqueDocs);
//     handleFilterModalClose();
//     return uniqueDocs;
//   };

//   try {
//     let results = [];

//     for (const accountStatus of accountStatusFilterOptions) {
//       let queries = [
//         where(
//           "isActive",
//           "==",
//           accountStatus === "active"
//             ? true
//             : accountStatus === "inactive"
//             ? false
//             : undefined
//         ),
//         ...reportedStatusFilterOptions.map((option) =>
//           where("reportedStatus", "==", option)
//         ),
//       ];

//       if (
//         dateSignupRange &&
//         dateSignupRange?.startDate &&
//         dateSignupRange?.endDate
//       ) {
//         queries.push(where("createdAt", ">=", dateSignupRange.startDate));
//         queries.push(where("createdAt", "<=", dateSignupRange.endDate));
//       }

//       const q = query(ContributorsRef, ...queries);
//       const querySnapshot = await getDocs(q);

//       const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
//         return {
//           id: doc.id,
//           ...doc.data(),
//         };
//       });

//       const accountStatusResults = await Promise.all(fetchDetailsPromises);
//       results = results.concat(accountStatusResults);
//     }

//     const uniqueResults = deduplicate(results);
//     setLoading(false);
//     return uniqueResults;
//   } catch (error) {
//     console.error("Error filtering users:", error);
//     setLoading(false);
//     return [];
//   }
// };

// export const getFilterGAUsers = async (
//   accountStatusFilterOptions,
//   reportedStatusFilterOptions,
//   dateSignupFilterOptions,
//   setLoading,
//   handleFilterModalClose
// ) => {
//   // Set loading to true at the beginning of the function
//   // setLoading(true);
//   const deduplicate = (arr) => {
//     const uniqueIds = new Set();
//     const uniqueDocs = [];
//     arr.forEach((doc) => {
//       if (!uniqueIds.has(doc.id)) {
//         uniqueIds.add(doc.id);
//         uniqueDocs.push(doc);
//       }
//     });
//     console.log("results:", uniqueDocs);
//     handleFilterModalClose();
//     return uniqueDocs;
//   };

//   try {
//     // Define the reference to your QuickTales collection
//     // let results = [];

//     let queries = [
//       ...accountStatusFilterOptions.map(
//         (option) =>
//           where(
//             "isActive",
//             "==",
//             option == "active" ? true : option == "inactive" ? false : undefined
//           )
//         // ...accountStatusFilterOptions.map((option) =>
//         //   where("status", "==", option)
//       ),

//       ...reportedStatusFilterOptions.map((option) =>
//         where("reportedStatus", "==", option)
//       ),
//     ];

//     // Add date range filter if provided
//     if (dateSignupFilterOptions.length > 0) {
//       let selectedDateOption;

//       if (Array.isArray(dateSignupFilterOptions)) {
//         // Example of finding a specific option, adjust logic as necessary
//         const dateRangeOption = dateSignupFilterOptions.find((option) =>
//           option.startsWith("Date Signup:")
//         );
//         if (dateRangeOption) {
//           selectedDateOption = "Custom Range"; // Indicate a custom range is selected
//         } else {
//           // Logic to set selectedDateOption based on other criteria
//           selectedDateOption = dateSignupFilterOptions[0]; // Example defaulting to the first option
//         }
//       } else {
//         selectedDateOption = dateSignupFilterOptions; // Directly use the string if it's not an array
//       }
//       // const dateRangeString = dateSignupFilterOptions.find((option) =>
//       //   option.startsWith("Date Signup:")
//       // );
//       // if (dateRangeString) {
//       //   const dates = dateRangeString.replace("Date Signup: ", "").split(" - ");
//       //   const startDate = moment(dates[0], "MM/DD/YYYY")
//       //     .startOf("day")
//       //     .toDate();
//       //   const endDate = moment(dates[1], "MM/DD/YYYY").endOf("day").toDate();

//       //   // Add date range conditions to the query
//       //   queries.push(where("createdAt", ">=", Timestamp.fromDate(startDate)));
//       //   queries.push(where("createdAt", "<=", Timestamp.fromDate(endDate)));
//       // }
//       switch (selectedDateOption) {
//         case "Custom Range":
//           const dateRangeOption = dateSignupFilterOptions.find((option) =>
//             option.startsWith("Date Signup:")
//           );
//           const dates = dateRangeOption
//             .replace("Date Signup: ", "")
//             .split(" - ");
//           const startDate = moment(dates[0], "MM/DD/YYYY")
//             .startOf("day")
//             .toDate();
//           const endDate = moment(dates[1], "MM/DD/YYYY").endOf("day").toDate();

//           // Add date range conditions to the query
//           queries.push(where("createdAt", ">=", Timestamp.fromDate(startDate)));
//           queries.push(where("createdAt", "<=", Timestamp.fromDate(endDate)));
//           break;
//         case "Today":
//           const todayStart = moment(new Date(), "MM/DD/YYYY")
//             .startOf("day")
//             .toDate();
//           const todayEnd = moment(new Date(), "MM/DD/YYYY")
//             .endOf("day")
//             .toDate();
//           queries.push(
//             where("createdAt", ">=", Timestamp.fromDate(todayStart))
//           );
//           queries.push(where("createdAt", "<=", Timestamp.fromDate(todayEnd)));
//           break;
//         case "Past Week":
//           const lastWeekStart = moment(new Date(), "MM/DD/YYYY")
//             .subtract(7, "days")
//             .startOf("day")
//             .toDate();
//           const lastWeekEnd = moment(new Date(), "MM/DD/YYYY")
//             .endOf("day")
//             .toDate();
//           queries.push(
//             where("createdAt", ">=", Timestamp.fromDate(lastWeekStart))
//           );
//           queries.push(
//             where("createdAt", "<=", Timestamp.fromDate(lastWeekEnd))
//           );
//           break;
//         case "Last 30 Days":
//           const last30DaysStart = moment(new Date(), "MM/DD/YYYY")
//             .subtract(30, "days")
//             .startOf("day")
//             .toDate();
//           const last30DaysEnd = moment(new Date(), "MM/DD/YYYY")
//             .endOf("day")
//             .toDate();
//           queries.push(
//             where("createdAt", ">=", Timestamp.fromDate(last30DaysStart))
//           );
//           queries.push(
//             where("createdAt", "<=", Timestamp.fromDate(last30DaysEnd))
//           );
//           break;
//         case "Last 12 Months":
//           const last12MonthsStart = moment(new Date(), "MM/DD/YYYY")
//             .subtract(12, "months")
//             .startOf("day")
//             .toDate();
//           const last12MonthsEnd = moment(new Date(), "MM/DD/YYYY")
//             .endOf("day")
//             .toDate();
//           queries.push(
//             where("createdAt", ">=", Timestamp.fromDate(last12MonthsStart))
//           );
//           queries.push(
//             where("createdAt", "<=", Timestamp.fromDate(last12MonthsEnd))
//           );
//           break;
//         default:
//           // Default case
//           break;
//       }
//     }

//     // Execute the query
//     const q = query(ContributorsRef, ...queries);
//     const querySnapshot = await getDocs(q);

//     // Convert to map to handle async operations
//     const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
//       return {
//         id: doc.id,
//         ...doc.data(),
//       };
//     });

//     // Wait for all fetches to complete
//     const results = await Promise.all(fetchDetailsPromises);

//     const uniqueResults = deduplicate(results);
//     handleFilterModalClose(); // Assuming it's appropriate to close the modal here
//     return uniqueResults;
//   } catch (error) {
//     console.error("Error filtering users:", error);
//     setLoading(false);
//     return []; // Return an empty array in case of error
//   }
// };

export const uploadUserImageToStorage = async (file, userId) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `users/${userId}/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const getUserContributorInvites = async (userId) => {
  try {
    const queryRef = query(
      ContributorsInvitesRef,
      where("userId", "==", userId)
    );
    const response = await getDocs(queryRef);
    return response.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
  } catch (error) {
    console.log("Error fetching contributor invites:", error.message);
    return [];
  }
};

export const updateContributorInviteStatus = async (inviteId, data) => {
  try {
    const inviteRef = doc(db, "contributorsInvites", inviteId);
    return await updateDoc(inviteRef, data);
  } catch (error) {
    console.log("Error updating contributor invite:", error.message);
  }
};

// export const getUserGroups = async (userId) => {
//   try {
//     let temp = [];
//     //get groups created by user
//     const queryRef = query(GroupRef, where("createdBy", "==", userId));
//     //get groups where user is member
//     const memberQueryRef = query(
//       GroupRef,
//       where("members", "array-contains", userId)
//     );
//     const response = await getDocs(queryRef);
//     const memberResponse = await getDocs(memberQueryRef);

//     temp = [...response.docs, ...memberResponse.docs];

//     return temp;
//   } catch (error) {
//     console.log("Error fetching data from Firestore:", error.message);
//     // console.error("Error fetching data from Firestore:", error.message);
//     return [];
//   }
// };

// export const getUserLikes = async (userId) => {
//   try {
//     let temp = [];
//     const QTQueryRef = query(QuickTalesRef, where("createdBy", "==", userId));
//     const QTResponse = await getDocs(QTQueryRef);
//     QTResponse.docs.forEach(async (item) => {
//       const queryRef = query(QTLikesRef, where("quicktale", "==", item.id));
//       const response = await getDocs(queryRef);
//       temp = [...response.docs];
//     });

//     return temp;
//   } catch (error) {
//     console.log("Error fetching data from Firestore:", error.message);
//     // console.error("Error fetching data from Firestore:", error.message);
//     return [];
//   }
// };
